import { render, staticRenderFns } from "./BridgingBPJS.vue?vue&type=template&id=5d19748f&scoped=true&"
import script from "./BridgingBPJS.vue?vue&type=script&lang=js&"
export * from "./BridgingBPJS.vue?vue&type=script&lang=js&"
import style0 from "./BridgingBPJS.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BridgingBPJS.vue?vue&type=style&index=1&id=5d19748f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d19748f",
  null
  
)

export default component.exports